import type { ViewState } from '#components/Root/viewModel'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import Heading from '@vimcar/shared-components/components/Heading'
import Icon from '@vimcar/shared-components/components/Icon'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
// @ts-expect-error@2306
import colors from '@vimcar/shared-utils/styles/colors'
import cx from 'classnames'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomTextAndIcon = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      <div className={styles.centered}>
        <Icon fill={colors.colorPrimary} icon='check' size={55} />
      </div>
      <Heading className={cx(styles.iconLabel, styles.centered)} level='5'>
        {state.currentNode.subtext}
      </Heading>
    </StepContent>
    {viewModel.showButtons && (
      <BottomActions
        // @ts-expect-error@2322
        extraButtons={viewModel.buttons}
        onNext={viewModel.showContinue && viewModel.handleNext}
        showBack={viewModel.showBack}
        // @ts-expect-error@2339
        showClose={viewModel.showClose}
      />
    )}
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomTextAndIcon)
component.displayName = 'CustomTextAndIcon'
export default component
